export const months = [
  { value: 'January', label: 'January' },
  { value: 'February', label: 'February' },
  { value: 'March', label: 'March' },
  { value: 'April', label: 'April' },
  { value: 'May', label: 'May' },
  { value: 'June', label: 'June' },
  { value: 'July', label: 'July' },
  { value: 'August', label: 'August' },
  { value: 'September', label: 'September' },
  { value: 'October', label: 'October' },
  { value: 'November', label: 'November' },
  { value: 'December', label: 'December' }
];

export const dueDateTypes = [
  { value: 'First', label: 'First' },
  { value: 'Last', label: 'Last' },
  { value: 'Specific', label: 'Specific' }
];

export const monthDays = Array.from({ length: 31 }, (_, i) => ({
  value: (i + 1).toString(),
  label: (i + 1).toString()
}));

export const getCurrentMonth = () => {
  const today = new Date();
  return months[today.getMonth()].value;
};

export const calculateNextDueDate = (dueDateType, dueDateMonth, dueDateDay) => {
  if (dueDateType && dueDateMonth) {
    const monthIndex = months.findIndex(m => m.value === dueDateMonth);
    const currentYear = new Date().getFullYear();
    
    let dueDate;
    
    if (dueDateType === 'First') {
      dueDate = new Date(currentYear, monthIndex, 1);
    } else if (dueDateType === 'Last') {
      dueDate = new Date(currentYear, monthIndex + 1, 0); // Last day of month
    } else if (dueDateType === 'Specific' && dueDateDay) {
      dueDate = new Date(currentYear, monthIndex, parseInt(dueDateDay));
    }
    
    if (dueDate && dueDate < new Date()) {
      if (dueDateType === 'First') {
        dueDate.setMonth(dueDate.getMonth() + 1, 1);
      } else if (dueDateType === 'Last') {
        dueDate = new Date(currentYear, monthIndex + 2, 0);
      } else if (dueDateType === 'Specific') {
        dueDate.setMonth(dueDate.getMonth() + 1);
      }
    }
    
    return dueDate ? dueDate.toISOString().split('T')[0] : "";
  }
  return "";
};

export const getSchedulePreviewText = (dueDateType, dueDateMonth, dueDateDay) => {
  if (!dueDateType || !dueDateMonth) return '';
  
  const calculatedDate = calculateNextDueDate(dueDateType, dueDateMonth, dueDateDay);
  
  if (dueDateType === 'First') {
    return ` First day of every month (Next: ${calculatedDate ? new Date(calculatedDate).toLocaleDateString() : ''})`;
  } else if (dueDateType === 'Last') {
    return ` Last day of every month (Next: ${calculatedDate ? new Date(calculatedDate).toLocaleDateString() : ''})`;
  } else if (dueDateType === 'Specific') {
    if (!dueDateDay) return '';
    return ` Every ${dueDateDay} of the month (Next: ${calculatedDate ? new Date(calculatedDate).toLocaleDateString() : ''})`;
  }

  return '';
};

export const shouldShowDay = (dueDateType) => {
  return dueDateType === 'Specific';
};

export const shouldShowMonth = (dueDateType) => {
  return dueDateType && dueDateType !== '';
};